<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div v-if="keyVault.sharedType" class="dialog-title" v-t="'message.action_add_shared_key'"></div>
                <div v-else class="dialog-title" v-t="'message.action_add_private_key'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="150px" >
                        <div class="dialog-form-item">
                            <!-- display name -->
                            <el-form-item prep="displayName" ref="displayName">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_display_name'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="displayName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                            <!-- client id -->
                            <el-form-item prep="clientId" ref="clientId">
                                <div slot="label" style="text-align:left"><span>Client ID</span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="clientId" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.clientId.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                            <!-- client secret -->
                            <el-form-item prep="clientSecret" ref="clientSecret">
                                <div slot="label" style="text-align:left"><span>Client Secret</span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="clientSecret" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.clientSecret.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                            <!-- service account -->
                            <el-form-item prep="serviceAccount" ref="serviceAccount">
                                <div slot="label" style="text-align:left"><span>Service Account</span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="serviceAccount" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.serviceAccount.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                            <!-- private Key -->
                            <el-form-item prep="privateKey" ref="privateKey"> <!-- this input value is dummy. instead, uploadFile is used.  -->
                                <div slot="label" style="text-align:left"><span>Private Key</span> <span class="required" v-t="'message.item_required'"></span></div>
                                <label for="file_upload">
                                    <img src="../assets/icon_attach.svg" class="button-icon"/><span v-t="'message.action_selection'"/>
                                    <input id="file_upload" @change="selectedFile" type="file" name="file" style="display:none"/>
                                </label>
                                <span v-if="showUploadInfo">
                                    <span v-if="uploadFile != null" class='selected-filename'>{{ uploadFile.name }}</span>
                                </span>
                            </el-form-item>
                            <!-- bot name -->
                            <el-form-item prep="botName" ref="botName">
                                <div slot="label" style="text-align:left"><span>Bot Name</span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="botName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.botName.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                            <!-- bot id -->
                            <el-form-item prep="botId" ref="botId">
                                <div slot="label" style="text-align:left"><span>Bot ID</span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="botId" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.botId.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                            <!-- bot secret -->
                            <el-form-item prep="botSecret" ref="botSecret">
                                <div slot="label" style="text-align:left"><span>Bot Secret</span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="botSecret" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.botSecret.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableButton" @click="addKey()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import charactercheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

export default {
    data() {
        return {
            inputForm: {
                displayName:      { validationRule: "reqDisplayName",       valid: false,    value: null,   isComposing: false },
                clientId:         { validationRule: "reqText",              valid: false,    value: null,   isComposing: false },
                clientSecret:     { validationRule: "reqText",              valid: false,    value: null,   isComposing: false },
                serviceAccount:   { validationRule: "reqText",              valid: false,    value: null,   isComposing: false },
                botName:          { validationRule: "reqText",              valid: false,    value: null,   isComposing: false },
                botId:            { validationRule: "numeric",              valid: false,    value: null,   isComposing: false },
                botSecret:        { validationRule: "reqText",              valid: false,    value: null,   isComposing: false },
            },
            disableButton: true,
            showUploadInfo: true,
        };
    },
    methods: {
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.$refs[eventTargetId].clearValidate();
                this.inputForm[eventTargetId].valid = true;
            } else {
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
                this.inputForm[eventTargetId].valid = false;
            }
            this.setButtonStatus();
        },
        InputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        setButtonStatus() {
            if (commonValidate.checkFormValidation(this.inputForm) && (this.uploadFile != null)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        addKey() {
            this.$emit('save', {
                sharedType: this.keyVault.sharedType,
                inputForm: this.inputForm,
                secretFile: this.uploadFile,
            });
        },
        selectedFile: function(e) {
            e.preventDefault();
            let files = e.target.files;
            this.uploadFile = files[0];
            this.setButtonStatus();
            this.reDrawUploadInfo();
        },
        reDrawUploadInfo() {
            this.showUploadInfo = false;
            let self = this;
            this.$nextTick(() => {
                 self.showUploadInfo = true;
            })
        },
    },
    created: function() {
    },
    props: [ 'appData', 'keyVault' ]
}
</script scoped>
<style scoped>

label {
    font-size: 14px;
    color: #333B48;
    background-color: #f6f6f6;
    padding: 6px;
    border-radius: 4px;
    border: solid 1px;
    line-height: 33px;
    border-color: #dcdfe6;
    cursor: pointer;
}

.selected-filename {
    padding-left: 10px;
}

</style>

